var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49851 9.12297C5.70567 8.8799 5.53691 8.50038 5.22164 8.50038H4.27771C4.27156 8.40486 4.26812 8.30859 4.26812 8.21151C4.26812 5.80601 6.18145 3.84903 8.53327 3.84903C9.66348 3.84903 10.6922 4.30112 11.4562 5.03759L12.7873 3.44493C11.6221 2.35472 10.1226 1.75757 8.53327 1.75757C6.84782 1.75757 5.26325 2.42891 4.07145 3.64787C2.87967 4.86687 2.2233 6.48758 2.2233 8.21148C2.2233 8.30814 2.22566 8.40441 2.22977 8.50035H1.43469C1.11941 8.50035 0.950626 8.87987 1.15782 9.12294L2.95141 11.2272L3.32815 11.6692L4.68075 10.0823L5.49851 9.12297Z",
    fill: "url(#paint0_linear_14_4172)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_14_4172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.43186 8.03214C4.63902 7.78908 4.47026 7.40956 4.15499 7.40956H3.21105C3.20491 7.31404 3.20147 7.21776 3.20147 7.12069C3.20147 4.71519 5.1148 2.75821 7.46662 2.75821C8.59682 2.75821 9.62559 3.2103 10.3896 3.94677L11.7206 2.35411C10.5554 1.2639 9.05597 0.666748 7.46662 0.666748C5.78117 0.666748 4.1966 1.33809 3.0048 2.55705C1.81302 3.77604 1.15665 5.39676 1.15665 7.12066C1.15665 7.21732 1.15901 7.31359 1.16312 7.40953H0.368036C0.05276 7.40953 -0.116024 7.78905 0.0911678 8.03211L1.88476 10.1364L2.2615 10.5784L3.6141 8.99147L4.43186 8.03214Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9088 7.89661L14.571 6.3271L13.7384 5.35034L12.5497 6.74492L11.5681 7.89661C11.3609 8.13968 11.5297 8.51919 11.845 8.51919H12.7878C12.6335 10.7823 10.7844 12.5753 8.5333 12.5753C7.55064 12.5753 6.64465 12.2335 5.92268 11.6602L4.59155 13.253C5.70669 14.1689 7.08249 14.6668 8.53333 14.6668C10.2188 14.6668 11.8034 13.9955 12.9952 12.7765C14.1161 11.63 14.7632 10.1281 14.8362 8.51922H15.6319C15.9472 8.51919 16.1159 8.13968 15.9088 7.89661Z",
    fill: "url(#paint1_linear_14_4172)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_14_4172",
    x: -1,
    y: -0.333252,
    width: 13.7207,
    height: 11.9116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14_4172"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14_4172",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_4172",
    x1: 6.92696,
    y1: 1.75757,
    x2: 6.92696,
    y2: 11.6692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EED4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BCC67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14_4172",
    x1: 10.2957,
    y1: 5.35034,
    x2: 10.2957,
    y2: 14.6668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EED4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BCC67"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.3d45a899898c16d501a753af611ff004.svg";
export { ForwardRef as ReactComponent };